import { default as breakpoints } from './screens.scss';

export const screens = Object.keys(breakpoints).reduce((obj, key) => {
  obj[key] = parseInt(breakpoints[key], 10);
  return obj;
}, {});
